__turbopack_context__.v({
  "avatar": "AppHeader-module__Usy_-q__avatar",
  "dropdown": "AppHeader-module__Usy_-q__dropdown",
  "header": "AppHeader-module__Usy_-q__header",
  "logo": "AppHeader-module__Usy_-q__logo",
  "logoLink": "AppHeader-module__Usy_-q__logoLink",
  "menuButton": "AppHeader-module__Usy_-q__menuButton",
  "navLink": "AppHeader-module__Usy_-q__navLink",
  "pageTitle": "AppHeader-module__Usy_-q__pageTitle",
  "profileButton": "AppHeader-module__Usy_-q__profileButton",
  "secondaryTitle": "AppHeader-module__Usy_-q__secondaryTitle",
  "secondaryTitleInput": "AppHeader-module__Usy_-q__secondaryTitleInput",
  "secondaryTitleInputStyles": "AppHeader-module__Usy_-q__secondaryTitleInputStyles",
  "titleContainer": "AppHeader-module__Usy_-q__titleContainer",
});
